<script lang="ts">
  import { ordersStore } from "../store";

  let currentPage = 1;
  let itemsPerPage = 10;

  $: totalPages = Math.ceil($ordersStore.length / itemsPerPage);
  $: paginatedOrders = $ordersStore.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage,
  );

  function changePage(page: number) {
    if (page >= 1 && page <= totalPages) {
      currentPage = page;
    }
  }
</script>

<div class="w-full p-6 relative">
  <div
    class="flex justify-between items-center mb-6 max-sm:flex-col max-sm:items-start max-sm:gap-4"
  >
    <h2
      class="text-5xl font-black uppercase tracking-wider text-gray-800 drop-shadow-sm"
    >
      Customer Orders
    </h2>
  </div>

  <hr class="h-px mb-8 bg-gray-300 border-0" />

  <div
    class="relative overflow-x-auto shadow-md sm:rounded-xl border border-gray-200"
  >
    <table class="w-full text-sm text-left">
      <thead
        class="text-sm font-bold uppercase bg-sky-50 text-sky-900 border-b-2 border-sky-200"
      >
        <tr>
          <th scope="col" class="px-6 py-5">Order ID</th>
          <th scope="col" class="px-6 py-5">Date</th>
          <th scope="col" class="px-6 py-5">Customer</th>
          <th scope="col" class="px-6 py-5">Value</th>
          <th scope="col" class="px-6 py-5 text-center">Status</th>
        </tr>
      </thead>
      <tbody class="text-base text-gray-700">
        {#each paginatedOrders as order}
          <tr class="bg-white border-b hover:bg-sky-50 transition duration-200">
            <td class="px-6 py-4 font-bold text-gray-900">{order.id}</td>
            <td class="px-6 py-4">{order.date}</td>
            <td class="px-6 py-4 font-semibold">{order.customer}</td>
            <td class="px-6 py-4 font-bold text-sky-600">${order.total}</td>
            <td class="px-6 py-4 text-center">
              <span
                class="px-3 py-1 rounded-full text-xs font-bold uppercase border {order.status ===
                'Delivered'
                  ? 'bg-green-100 text-green-700 border-green-200'
                  : order.status === 'Pending'
                    ? 'bg-amber-100 text-amber-700 border-amber-200'
                    : order.status === 'Processing'
                      ? 'bg-blue-100 text-blue-700 border-blue-200'
                      : 'bg-sky-100 text-sky-700 border-sky-200'}"
              >
                {order.status}
              </span>
            </td>
          </tr>
        {/each}
      </tbody>
    </table>
  </div>

  <div class="flex justify-center mt-10 gap-2 flex-wrap">
    <button
      class="px-4 py-2 bg-sky-500 hover:bg-amber-400 hover:text-black transition text-white rounded-lg disabled:opacity-50 disabled:hover:bg-sky-500 disabled:hover:text-white"
      disabled={currentPage === 1}
      on:click={() => changePage(currentPage - 1)}>Prev</button
    >
    {#each Array(totalPages) as _, i}
      <button
        class="px-4 py-2 rounded-lg transition duration-200 {currentPage ===
        i + 1
          ? 'bg-amber-400 text-black font-bold shadow-lg scale-110'
          : 'bg-gray-200 text-gray-700 hover:bg-sky-200'}"
        on:click={() => changePage(i + 1)}>{i + 1}</button
      >
    {/each}
    <button
      class="px-4 py-2 bg-sky-500 hover:bg-amber-400 hover:text-black transition text-white rounded-lg disabled:opacity-50 disabled:hover:bg-sky-500 disabled:hover:text-white"
      disabled={currentPage === totalPages}
      on:click={() => changePage(currentPage + 1)}>Next</button
    >
  </div>
</div>
